import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useJob from 'hooks/useJob';
import useJobStore from 'store/jobStore';
import { isJobInProgress } from 'utils/helpers';
import { Navigate } from 'react-router';
import withSeo from 'components/hoc/withSeo';
import HybridJob from './HybridJob';
import Job from './Job';
import JobErrorPage from './JobErrorPage';
import { auth, useAuthState } from '../../../api/services/firebase';
import { getSampleJob } from '../../../hooks/useRunABJob';

const JobPage = () => {
  const [user] = useAuthState(auth);
  const { id: jobId } = useParams();
  const location = useLocation();
  const sampleJob = getSampleJob();
  const redirectUrl = `/?open=login&back=${location.pathname.substring(1)}`;

  const isNotebook = location?.state?.isNotebook;
  useJob(jobId);

  const { isLoading, details, error } = useJobStore((state) => state.job);
  const resetJob = useJobStore((state) => state.reset);

  useEffect(() => () => {
    resetJob();
  }, []);

  const isInProgress = isJobInProgress(details?.runStatus);

  if (!user && jobId !== sampleJob.jobId) {
    return <Navigate to={redirectUrl} />;
  }

  if (error) {
    return <JobErrorPage error={error} />;
  }

  return isNotebook || details.isNotebook
    ? <HybridJob {...details} isInProgress={isInProgress} isLoading={isLoading} />
    : <Job {...details} isInProgress={isInProgress} isLoading={isLoading} />;
};

export default withSeo(JobPage);
